import { Component } from '@angular/core';

interface HelpCard {
  image: string;
  title: string;
  description: string;
}

@Component({
  selector: 'app-organizer-help',
  imports: [],
  templateUrl: './organizer-help.html',
  styleUrl: './organizer-help.css',
})
export class OrganizerHelp {
  helps: HelpCard[] = [
    {
      image: 'organizer/help/help1.png',
      title: $localize`:organizer.help|Card 1 title@@organizer.help.card1.title:Minimize non-payment rate`,
      description: $localize`:organizer.help|Card 1 description@@organizer.help.card1.desc:Forget scrolling through chat history to see who paid. Players book and pay upfront through our secure checkout.`,
    },
    {
      image: 'organizer/help/help2.png',
      title: $localize`:organizer.help|Card 2 title@@organizer.help.card2.title:Worry less about late cancellations`,
      description: $localize`:organizer.help|Card 2 description@@organizer.help.card2.desc:Protect your revenue with flexible refund windows. Set cancellation deadlines to fill empty spots or retain the booking fee for no-shows.`,
    },
    {
      image: 'organizer/help/help3.png',
      title: $localize`:organizer.help|Card 3 title@@organizer.help.card3.title:Take control of your finances`,
      description: $localize`:organizer.help|Card 3 description@@organizer.help.card3.desc:Track every transaction and view real-time revenue reports in one clean dashboard.`,
    },
    {
      image: 'organizer/help/help4.png',
      title: $localize`:organizer.help|Card 4 title@@organizer.help.card4.title:Organizing booking`,
      description: $localize`:organizer.help|Card 4 description@@organizer.help.card4.desc:Our platform automates rosters and waitlists, ensuring your event stays organized.`,
    },
    {
      image: 'organizer/help/help5.png',
      title: $localize`:organizer.help|Card 5 title@@organizer.help.card5.title:Focusing on scaling your business`,
      description: $localize`:organizer.help|Card 5 description@@organizer.help.card5.desc:With the logistics handled, you can shift your energy toward running more games, reaching more players, and expanding your community.`,
    },
  ];
}
